"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUTTON_SIZES = void 0;
exports.BUTTON_SIZES = {
    none: { small: { width: 50, height: 20 }, large: { width: 67, height: 28 } },
    above: { small: { width: 50, height: 56 }, large: { width: 67, height: 78 } },
    beside: {
        small: { width: 50, height: 20 },
        large: { width: 67, height: 28 },
    },
};
//# sourceMappingURL=constants.js.map